/* tslint:disable:typedef-whitespace no-trailing-whitespace */

import {TaskUpdate, TaskUpdateType} from "@/models/task.update";

/**
 *
 * @class TaskSimImportComplete
 *
 * @brief sentinel progress event; remote simulation importing is completed ok
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      October 2024
 *
 */
export class TaskSimImportComplete extends TaskUpdate {

  /** the error message */
  public message: string;

  /** the icon to use for the file type */
  public icon:     string;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id of the task progress stream to clear (the context)
   * @param message  the final message to show to the user
   * @param icon     the icon (left side) to use if overriding
   */
  constructor(id: string, message: string, icon?: string) {

    super(id, TaskUpdateType.Complete,100.0);

    this.message = message;

    this.icon     = '/assets/images/google-storage-32.png';

    if (icon) {

      this.icon = icon;
    }
  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <img alt="Simulation Complete!" class="tsp-icon" src="${this.icon}" width="32"></img>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px); vertical-align: top; margin-top: 4px;">

    <div style="display: block;">
      <span class="tsp-label">${this.message}</span>
    </div>

  </div>

</div>`;
  }

  /** is this task complete? */
  isComplete(): boolean {

    return true;
  }

}
